<template>
  <div class="m-2 mx-auto my-5 max-w-3xl py-2">
    <div class="my-5">
      <span class="font-bold">Popular Searches:</span>
    </div>
    <div
      v-for="(criteriaItems, propertyName) in unselectedSuggestedKeywords"
      :key="propertyName"
      class="my-3 md:flex md:flex-row"
    >
      <div v-if="criteriaItems.length">
        <p class="text-vgocean my-1 text-sm font-semibold uppercase">
          {{ propertyName }}
        </p>
        <v-chip
          v-for="role in criteriaItems"
          :key="role.id"
          size="large"
          closable
          pill
          class="my-1 mr-1 px-5 py-3 text-center shadow-lg"
          :close-icon="
            keywordSelected(role)
              ? 'mdi-check'
              : 'mdi-checkbox-blank-circle-outline'
          "
          :class="computedColorPerCriteria(propertyName)"
          variant="outlined"
          @click:close="handleAddingSuggestedKeyword(role, propertyName)"
          @click="handleAddingSuggestedKeyword(role, propertyName)"
        >
          <span class="truncate text-black">{{ role }}</span>
        </v-chip>
      </div>
    </div>
  </div>
</template>
<script>
import { mapStores } from 'pinia';
import { useCheckoutStore } from '@/stores/checkout';
import {
  getSuggestedCriteria,
  searchCriteria,
} from '@/services/matchingService';

export default {
  name: 'SuggestedKeywords',

  data() {
    return {
      criteria: {
        roles: [],
        skills: [],
        tools: [],
      },
      oldKeywords: {},
    };
  },
  computed: {
    ...mapStores(useCheckoutStore),
    unselectedSuggestedKeywords() {
      let suggestedKeywords = this.criteria;
      let keywords = this.checkoutStore.enteredKeywords || {};

      return Object.keys(this.criteria).reduce(function (result, key) {
        result[key] = suggestedKeywords?.[key]?.filter(
          (keyword) => !keywords[key]?.includes(keyword)
        );
        return result;
      }, {});
    },
  },
  watch: {
    'checkoutStore.matchingCriteria.keywords': {
      immediate: true,
      async handler() {
        let params = new URLSearchParams();
        let deletedKeywords = {};
        Object.keys(this.checkoutStore.matchingCriteria.keywords ?? {})
          .filter((key) => key !== 'default')
          .some((criteria) => {
            if (!this.oldKeywords[criteria]) {
              this.oldKeywords[criteria] = [];
            }
            if (
              this.checkoutStore.matchingCriteria.keywords[criteria].length >
              this.oldKeywords[criteria].length
            ) {
              const newKeyword = this.checkoutStore.matchingCriteria.keywords[
                criteria
              ].find(
                (keyword) => !this.oldKeywords[criteria].includes(keyword)
              );
              if (newKeyword) {
                params.append('last', `${criteria}:${newKeyword}`);
                return true;
              }
            } else if (
              this.checkoutStore.matchingCriteria.keywords[criteria].length <
              this.oldKeywords[criteria].length
            ) {
              const deletedKeyword = this.oldKeywords[criteria].find(
                (keyword) =>
                  !this.checkoutStore.matchingCriteria.keywords[
                    criteria
                  ].includes(keyword)
              );
              if (deletedKeyword) {
                deletedKeywords[criteria] = [deletedKeyword];
                return true;
              }
            }
          });
        Object.keys(this.checkoutStore.matchingCriteria.keywords ?? {}).forEach(
          (criteria) => {
            this.checkoutStore.matchingCriteria.keywords[criteria].forEach(
              (value) => {
                params.append(criteria, value);
              }
            );
          }
        );
        this.oldKeywords = JSON.parse(
          JSON.stringify(this.checkoutStore.matchingCriteria.keywords ?? {})
        );

        const { roles, skills, tools } = await getSuggestedCriteria(
          params.toString()
        ).catch(() => {
          return [];
        });

        this.criteria.roles = [
          ...new Set([
            ...(deletedKeywords.roles || []),
            ...roles.map((role) => role.value),
          ]),
        ];
        this.criteria.skills = [
          ...new Set([
            ...(deletedKeywords.skills || []),
            ...skills.map((skill) => skill.value),
          ]),
        ];
        this.criteria.tools = [
          ...new Set([
            ...(deletedKeywords.tools || []),
            ...tools.map((tool) => tool.value),
          ]),
        ];
      },
    },
  },
  methods: {
    computedColorPerCriteria(criteria) {
      switch (criteria) {
        case 'roles':
          return 'border-vgsoftblue border-1 border-solid';
        case 'skills':
          return 'border-vgsoftpurple border-1 border-solid';
        case 'tools':
          return 'border-vgsoftcyan border-1 border-solid';
        default:
          return 'border-vgocean border-1 border-solid';
      }
    },
    keywordSelected(keyword) {
      return this.checkoutStore.flattedEnteredKeywords.find(
        (enteredKeyword) => enteredKeyword === keyword
      );
    },
    async handleAddingSuggestedKeyword(keyword, criteria) {
      if (criteria === 'tools') {
        const searchResult = await searchCriteria([
          `searchQuery=${keyword}`,
          `types[]=tool`,
          `pagination.sortBy[]=value`,
        ])
          .then((data) => data.find((item) => item.value === keyword))
          .catch((error) => {
            this.$root.$snackbar.error(
              error?.data?.message ??
                'An Error occurred, please try again later.'
            );

            return [];
          });

        this.checkoutStore.selectKeyword({
          keyword,
          id: searchResult?.id || null,
          criteria,
        });
      } else if (criteria === 'skills') {
        const searchResult = await searchCriteria([
          `searchQuery=${keyword}`,
          `types[]=skill`,
          `pagination.sortBy[]=value`,
        ])
          .then((data) => data.find((item) => item.value === keyword))
          .catch((error) => {
            this.$root.$snackbar.error(
              error?.data?.message ??
                'An Error occurred, please try again later.'
            );

            return [];
          });

        this.checkoutStore.selectKeyword({
          keyword,
          id: searchResult?.id || null,
          criteria,
        });
      } else {
        this.checkoutStore.selectKeyword({ keyword, criteria });
      }
    },
  },
};
</script>
<style scoped>
.v-chip.v-chip--outlined.v-chip.v-chip {
  background-color: rgb(255, 255, 255, 1) !important;
}
</style>
